{
  "SET_NEW_PASSWORD": {
    "TITLE": "Set new password",
    "PASSWORD": {
      "LABEL": "Lozinka",
      "PLACEHOLDER": "Lozinka",
      "ERROR": "Lozinka je prekratka."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm password",
      "PLACEHOLDER": "Potvrdite lozinku",
      "ERROR": "Lozinke se ne poklapaju."
    },
    "API": {
      "SUCCESS_MESSAGE": "Lozinka je uspešno promenjena.",
      "ERROR_MESSAGE": "Could not connect to Woot server. Please try again."
    },
    "CAPTCHA": {
      "ERROR": "Potvrda je istekla. Molim vas ponovo rešite captcha."
    },
    "SUBMIT": "Pošalji"
  }
}
